import axios from "../../axios";

const deleteBankAccountPrivate = async function (accessToken, id) {
    try {
        const response = await axios.get('/bank-account/bank-account-private/deleteBankAccountPrivate', {
            headers: {
                'Authorization': accessToken
            },
            params: {
                id
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default deleteBankAccountPrivate;
